import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react'
import QRCodeReact from 'qrcode.react'

import { Page } from '../'
import * as api from '../../lib/api'
import { user } from '../../stores'

import Loading from '../../components/loading'
import { NavInSites } from '../../components/nav'
import Picture from '../../components/picture'

const OneExperience = ({ experience, resource }) => {
  const style = {
    height: '120px',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }
  if (resource && resource.hd && resource.hd.file) {
    style.backgroundImage = 'url(' + api.resources.getUrl(resource.hd.file) + ')'
  }
  return (
    <div style={style}>
      <h4>{experience.name}</h4>
    </div>
  )
}
const TwoExperiences = ({ experiences, resources }) => {
  const [one, two] = experiences

  const style = {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    margin: '0.1em',
    flex: 1
  }
  const resourceOne = resources && resources[one.picture]
  const resourceTwo = resources && resources[two.picture]
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flex: 1
      }}
    >
      <div
        style={{
          ...style,
          backgroundImage: resourceOne && resourceOne.hd ? 'url(' + api.resources.getUrl(resourceOne.hd.file) + ')' : ''
        }}
      >
        <h4>{one.name}</h4>
      </div>
      <div
        style={{
          ...style,
          backgroundImage: resourceTwo && resourceTwo.hd ? 'url(' + api.resources.getUrl(resourceTwo.hd.file) + ')' : ''
        }}
      >
        <h4>{two.name}</h4>
      </div>
    </div>
  )
}
const ThreeExperiences = ({ experiences, resources }) => {
  const [one, two, three] = experiences

  const resourceOne = resources && resources[one.picture]
  const resourceTwo = resources && resources[two.picture]
  const resourceThree = resources && resources[three.picture]

  const style = {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    margin: '0.1em',
    flex: 1
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          ...style,
          backgroundImage: resourceOne && resourceOne.hd ? 'url(' + api.resources.getUrl(resourceOne.hd.file) + ')' : '',
          height: '70px',
          backgroundSize: 'cover'
        }}
      >
        <h4>{one.name}</h4>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1
        }}
      >
        <div
          style={{
            ...style,
            backgroundImage: resourceTwo && resourceTwo.hd ? 'url(' + api.resources.getUrl(resourceTwo.hd.file) + ')' : ''
          }}
        >
          <h4>{two.name}</h4>
        </div>
        <div
          style={{
            ...style,
            backgroundImage: resourceThree && resourceThree.hd ? 'url(' + api.resources.getUrl(resourceThree.hd.file) + ')' : ''
          }}
        >
          <h4>{three.name}</h4>
        </div>
      </div>
    </div>
  )
}
const MoreExperiences = ({ experiences, resources }) => {
  const [one, two] = experiences
  const resourceOne = resources && resources[one.picture]
  const resourceTwo = resources && resources[two.picture]

  const style = {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    margin: '0.1em',
    flex: 1
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          ...style,
          backgroundImage: resourceOne && resourceOne.hd ? 'url(' + api.resources.getUrl(resourceOne.hd.file) + ')' : '',
          height: '70px',
          backgroundSize: 'cover'
        }}
      >
        <h4>{one.name}</h4>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1
        }}
      >
        <div
          style={{
            ...style,
            backgroundImage: resourceTwo && resourceTwo.hd ? 'url(' + api.resources.getUrl(resourceTwo.hd.file) + ')' : ''
          }}
        >
          <h4>{two.name}</h4>
        </div>
        <div
          style={{
            flex: 1
          }}
        >
          <h4
            style={{
              display: 'block',
              height: '100%',
              fontSize: '24px',
              whiteSpace: 'normal'
            }}
          >
            +{experiences.length - 2}
            <br />
          </h4>
        </div>
      </div>
    </div>
  )
}

class SitePreview extends Component {
  state = {
    resources: {},
    experiences: []
  }

  updateResources(experiences) {
    if (!experiences) {
      return
    }

    const loadedResources = {}
    const promises = Object.values(experiences)
      .filter((experience, index) => index <= 3)
      .filter(experience => !!experience.picture)
      .filter(experience => !this.state.experiences.includes(experience._id))
      .map(experience => {
        return api.resources.get(experience.picture).then(resource => {
          resource && (loadedResources[resource._id] = resource)
        })
      })
    this.setState({ experiences })
    Promise.all(promises).then(() => {
      this.setState({ resources: loadedResources })
    })
  }

  componentWillReceiveProps(nextProps) {
    this.updateResources(nextProps.experiences)
  }

  componentDidMount() {
    this.updateResources(this.props.experiences)
  }

  addToFavs = e => {
    user.favs.push(this.props.site._id)
    e.preventDefault()
  }

  removeFromFavs = e => {
    user.favs.remove(this.props.site._id)
    e.preventDefault()
  }

  render() {
    const { site, experiences } = this.props
    const { resources } = this.state
    const favs = user.favs
    return (
      <Link to={'/site/' + site._id} className="site-preview">
        <h3>
          {favs.includes(site._id) ? (
            <i className="fa fa-star pull-right" onClick={this.removeFromFavs} />
          ) : (
            <i className="fa fa-star-o pull-right" onClick={this.addToFavs} />
          )}
          <span className="site-preview-count">
            {experiences.length} {experiences.length > 1 ? 'expériences' : 'expérience'}
          </span>
          <span className="site-preview-name">{site.name}</span>
        </h3>
        {experiences.length === 1 && <OneExperience experience={experiences[0]} resource={resources[experiences[0].picture]} />}
        {experiences.length === 2 && <TwoExperiences experiences={experiences} resources={resources} />}
        {experiences.length === 3 && <ThreeExperiences experiences={experiences} resources={resources} />}
        {experiences.length > 3 && <MoreExperiences experiences={experiences} resources={resources} />}
      </Link>
    )
  }
}

const MobxSitePreview = observer(SitePreview)

// Filtres à facettes alimentés par le schéma de /parameters/forms/experience.json.
// Pour en ajouter un nouveau (enum), il suffit de l'ajouter ici : les options
// (valeurs + libellés) sont lues automatiquement dans le schéma.
const ENUM_FILTERS = [
  { key: 'typeEG', label: "Type d'Explor Games" },
  { key: 'locale', label: 'Langue' }
]

class ExperiencePreview extends Component {
  render() {
    const experience = this.props.experience
    return (
      <Link to={'/site/' + experience.siteId + '/experience/' + experience._id} className="experience-preview">
        <Picture resourceId={experience.picture} />
        <h3>{experience.name + '-' + experience.locale}</h3>
      </Link>
    )
  }
}

export default class Sites extends Component {
  state = {
    sites: [],
    filter: '',
    filteredSites: [],
    experiences: [],
    loading: false,
    isAdmin: false,
    isExpert: false,
    pageSize: 15,
    currentPage: 0,
    schema: null,
    filtersOpen: false,
    enumFilters: {},
    readyMade: 'all'
  }

  componentDidMount() {
    this.setState({ loading: true })
    api.sites
      .list()
      .then(sites => {
        this.setState({ sites, filteredSites: sites })
        return api.experiences.list()
      })
      .then(experiences => {
        this.setState({ experiences, loading: false })
      })
      .then(() => this.setState({ loading: false }))

    api.users.amIAnAdmin().then(isAdmin => {
      this.setState({ isAdmin })
    })
    api.users.amIAnExpert().then(isExpert => {
      this.setState({ isExpert })
    })

    fetch('/parameters/forms/experience.json')
      .then(res => res.json())
      .then(json => {
        this.setState({ schema: json && json.schema && json.schema.properties })
      })
      .catch(() => {})
  }

  getOptions(key) {
    const { schema } = this.state
    const prop = schema && schema[key]
    if (!prop || !prop.enum) {
      return []
    }
    return prop.enum
      .map((value, index) => ({
        value,
        label: (prop.enumNames && prop.enumNames[index]) || String(value)
      }))
      .filter(option => option.value !== null && option.value !== undefined)
  }

  toggleEnumFilter = (key, value) => {
    this.setState(prev => {
      const current = prev.enumFilters[key] || []
      const next = current.includes(value) ? current.filter(v => v !== value) : [...current, value]
      return {
        enumFilters: { ...prev.enumFilters, [key]: next },
        currentPage: 0
      }
    })
  }

  setReadyMade = value => {
    this.setState({ readyMade: value, currentPage: 0 })
  }

  resetFilters = () => {
    this.setState({ enumFilters: {}, readyMade: 'all', currentPage: 0 })
  }

  hasActiveFacets() {
    const { enumFilters, readyMade } = this.state
    if (readyMade !== 'all') {
      return true
    }
    return ENUM_FILTERS.some(f => (enumFilters[f.key] || []).length > 0)
  }

  matchFacets(experience) {
    const { enumFilters, readyMade } = this.state
    for (const f of ENUM_FILTERS) {
      const selected = enumFilters[f.key] || []
      if (selected.length > 0 && !selected.includes(experience[f.key])) {
        return false
      }
    }
    if (readyMade !== 'all') {
      const wantReadyMade = readyMade === 'yes'
      if (!!experience.readyMade !== wantReadyMade) {
        return false
      }
    }
    return true
  }

  normalize(str) {
    return (str || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
  }

  renderFilters(resultsCount) {
    const { filtersOpen, enumFilters, readyMade } = this.state
    const hasActiveFacets = this.hasActiveFacets()

    return (
      <div className={'sites-filters' + (filtersOpen ? ' is-open' : '')}>
        <div className="sites-filters-bar">
          <button
            type="button"
            className="btn btn-default sites-filters-toggle"
            onClick={() => this.setState({ filtersOpen: !filtersOpen })}
          >
            <i className="fa fa-sliders" /> Filtres
            {hasActiveFacets && <span className="sites-filters-dot" />}
          </button>
          <span className="sites-filters-count">
            {resultsCount} {resultsCount > 1 ? 'résultats' : 'résultat'}
          </span>
          {hasActiveFacets && (
            <button type="button" className="btn btn-link sites-filters-reset" onClick={this.resetFilters}>
              Réinitialiser
            </button>
          )}
        </div>

        {filtersOpen && (
          <div className="sites-filters-panel">
            {ENUM_FILTERS.map(f => {
              const options = this.getOptions(f.key)
              if (!options.length) {
                return null
              }
              const selected = enumFilters[f.key] || []
              return (
                <div className="sites-filter-group" key={f.key}>
                  <span className="sites-filter-label">{f.label}</span>
                  <div className="sites-filter-options">
                    {options.map(option => (
                      <button
                        type="button"
                        key={String(option.value)}
                        className={'sites-filter-chip' + (selected.includes(option.value) ? ' is-active' : '')}
                        onClick={() => this.toggleEnumFilter(f.key, option.value)}
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                </div>
              )
            })}

            <div className="sites-filter-group">
              <span className="sites-filter-label">Pré-édité</span>
              <div className="sites-filter-options">
                {[
                  { value: 'all', label: 'Tous' },
                  { value: 'yes', label: 'Oui' },
                  { value: 'no', label: 'Non' }
                ].map(option => (
                  <button
                    type="button"
                    key={option.value}
                    className={'sites-filter-chip' + (readyMade === option.value ? ' is-active' : '')}
                    onClick={() => this.setReadyMade(option.value)}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  render() {
    let { error, loading, filter, sites, pageSize, currentPage, experiences, isAdmin } = this.state
    const hasActiveFacets = this.hasActiveFacets()
    const filteredSites = sites
      .filter(s => {
        const matchesText =
          !filter ||
          this.normalize(s.name).indexOf(this.normalize(filter)) >= 0 ||
          experiences.some(xp => xp.siteId === s._id && this.normalize(xp.name).indexOf(this.normalize(filter)) >= 0)
        if (!matchesText) {
          return false
        }
        if (!hasActiveFacets) {
          return true
        }
        return experiences.some(xp => xp.siteId === s._id && this.matchFacets(xp))
      })
      .sort((s1, s2) => {
        if (user.favs.includes(s1._id) && !user.favs.includes(s2._id)) {
          return -1
        }
        if (user.favs.includes(s2._id) && !user.favs.includes(s1._id)) {
          return 1
        }
        return this.normalize(s1.name).localeCompare(this.normalize(s2.name))
      })

    const pages = []
    for (let index = 0; index < Math.ceil(filteredSites.length / pageSize); index++) {
      pages.push(index)
    }
    if (currentPage >= pages.length) {
      currentPage = pages.length - 1
    }
    return (
      <Page>
        <NavInSites />
        <div id="content">
          {error && <p>{error}</p>}
          {loading && <Loading />}
          <input
            type="search"
            className="form-control"
            value={filter}
            onChange={e => this.setState({ filter: e.target.value, currentPage: 0 })}
            placeholder="Rechercher"
          />

          {this.renderFilters(filteredSites.length)}

          <div className="sites-container">
            {filteredSites.map((site, index) => {
              if (index < currentPage * pageSize) {
                return null
              }
              if (index >= (currentPage + 1) * pageSize) {
                return null
              }
              return <MobxSitePreview site={site} key={site._id} experiences={experiences.filter(xp => xp.siteId === site._id)} />
            })}
          </div>
          {!sites.length && (
            <div className="experience-preview-container">
              {experiences.map(experience => {
                return <ExperiencePreview experience={experience} key={experience._id} />
              })}
            </div>
          )}

          <div
            aria-label="Page navigation"
            style={{
              width: '100%',
              textAlign: 'center'
            }}
          >
            <ul className="pagination">
              {currentPage > 0 && (
                <li>
                  <span
                    aria-label="Previous"
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      this.setState({
                        currentPage: currentPage - 1
                      })
                    }
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </span>
                </li>
              )}
              {pages.map(page => {
                return (
                  <li key={page} className={page === currentPage ? 'active' : ''}>
                    <span style={{ cursor: 'pointer' }} onClick={() => this.setState({ currentPage: page })}>
                      {page + 1}
                    </span>
                  </li>
                )
              })}
              {currentPage !== pages.length - 1 && (
                <li>
                  <span
                    style={{ cursor: 'pointer' }}
                    aria-label="Next"
                    onClick={() =>
                      this.setState({
                        currentPage: currentPage + 1
                      })
                    }
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </span>
                </li>
              )}
            </ul>
          </div>
          {<h2>QrCode à scanner pour ouvrir la liste des sites dans l'application explorgames</h2>}
          <QRCodeReact
            value="https://workshop.explor.games/site/"
            style={{ padding: '10px' }}
            size={276}
            includeMargin
            level="M"
          />
          {isAdmin && (
            <Link
              to="/site/"
              className="btn btn-block btn-primary"
              style={{
                clear: 'both'
              }}
            >
              Créer un nouveau site
            </Link>
          )}
        </div>
        <div id="app-preview" />
      </Page>
    )
  }
}
